import React from 'react'
import "./Navbar.css"
function Navbar() {
    return (
        <div className="nav">
            <h1 className="navBrand">Show-my-Tickets</h1>
        </div>
    )
}

export default Navbar
